"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripAutoCalculate = exports.tripListForDriverNearbyNotificationEligibility = exports.tripListForEarnings = exports.tripListForDelayedEarnings = exports.tripListForInstantEarnings = exports.tripListForFeedbackAndDriverId = exports.tripUpdateEstimate = exports.tripUpdateDriverEarningsD = exports.tripUpdate = exports.tripReadHasSentNearbyNotification = exports.tripRead = void 0;
const moment_1 = __importDefault(require("moment"));
const deserializeBoolean_1 = __importDefault(require("../models/deserializeBoolean"));
const PricingFormula_1 = require("../models/PricingFormula");
const Trip_1 = require("../models/Trip");
const TripType_1 = require("../models/TripType");
const cleanForFirebase_1 = __importDefault(require("../util/cleanForFirebase"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const TripType_2 = require("./../models/TripType");
const Driver_1 = require("./Driver");
// CRUD operations
const ROOT_PATH = 'trips';
const PATH = (customerId) => `/${ROOT_PATH}/${customerId}`;
async function tripRead(customerId, tripId, database) {
    const result = await database.read(customerId ? PATH(customerId) : 'trips-all', tripId);
    return (0, Trip_1.tripDeserialize)(result.value, result.id);
}
exports.tripRead = tripRead;
async function tripReadHasSentNearbyNotification(customerId, tripId, database) {
    var _a;
    const result = await database.read(`${PATH(customerId)}/${tripId}`, 'hasSentNearbyNotification');
    return (0, deserializeBoolean_1.default)((_a = result.value) !== null && _a !== void 0 ? _a : false);
}
exports.tripReadHasSentNearbyNotification = tripReadHasSentNearbyNotification;
function tripUpdate(customerId, tripId, values, database) {
    return database.update(PATH(customerId), tripId, (0, cleanForFirebase_1.default)(values));
}
exports.tripUpdate = tripUpdate;
async function tripUpdateDriverEarningsD(trip, database, firestore) {
    // check if override is in place
    if (trip.didOverrideDriverEarnings) {
        console.log('Ignoring; driver earnings was manually set');
        return;
    }
    // calculate fee, including cancelation logic:
    // deliveries are manual
    // rideshare cancelation is $0 if driver cancels, or equal to late fees if the rider cancels
    let driverEarningsD;
    if (trip.type === 'delivery') {
        driverEarningsD = await (0, PricingFormula_1.pricingFormulaTotalForTrip)('payout', trip, database, firestore);
    }
    else {
        switch (trip.status) {
            case 'CANCELED-BY-DRIVER': {
                driverEarningsD = 0;
                break;
            }
            case 'CANCELED-BY-RIDER': {
                const lateFeesD = (0, Trip_1.tripLateFeesAmountC)(trip) / 100;
                console.log({ lateFeesD });
                driverEarningsD = lateFeesD;
                break;
            }
            default: {
                driverEarningsD = await (0, PricingFormula_1.pricingFormulaTotalForTrip)('payout', trip, database, firestore);
                break;
            }
        }
    }
    // check result
    driverEarningsD = Math.round(Math.max(driverEarningsD, 0));
    // update trip
    console.log({ driverEarningsD });
    await tripUpdate(trip.customerId, trip.id, {
        driverEarningsD,
        cashedOutAt: -1,
    }, database);
}
exports.tripUpdateDriverEarningsD = tripUpdateDriverEarningsD;
async function tripUpdateEstimate(trip, database, firestore) {
    if (trip.didOverrideEstimate) {
        console.log('Ignoring; estimate was manually set');
        return;
    }
    const estimate = await (0, PricingFormula_1.pricingFormulaTotalForTrip)('invoice', trip, database, firestore);
    console.log({ estimate });
    await tripUpdate(trip.customerId, trip.id, {
        estimate,
    }, database);
}
exports.tripUpdateEstimate = tripUpdateEstimate;
async function tripListForFeedbackAndDriverId(driverId, firestore) {
    const results = await firestore.list(ROOT_PATH, {
        orderBy: 'riderFeedbackTimestampMs',
        orderByDirection: 'desc',
        where: [['driverId', '==', driverId]],
    });
    return results.map(result => (0, Trip_1.tripDeserialize)(result.value, result.id));
}
exports.tripListForFeedbackAndDriverId = tripListForFeedbackAndDriverId;
function tripListForInstantEarnings(driverId, firestore) {
    return tripListForEarnings(driverId, TripType_2.tripTypeRideshare, firestore);
}
exports.tripListForInstantEarnings = tripListForInstantEarnings;
function tripListForDelayedEarnings(driverId, firestore) {
    return tripListForEarnings(driverId, TripType_1.tripTypeNonRideshare, firestore);
}
exports.tripListForDelayedEarnings = tripListForDelayedEarnings;
async function tripListForEarnings(driverId, tripTypes, firestore) {
    const results = await firestore.list(ROOT_PATH, {
        where: [
            ['driverId', '==', driverId],
            ['cashedOutAt', '==', -1],
            ['driverEarningsD', '>', 0],
            ['status', '==', 'COMPLETED'],
        ],
    });
    return results.map(result => (0, Trip_1.tripDeserialize)(result.value, result.id)).filter(trip => tripTypes.includes(trip.type));
}
exports.tripListForEarnings = tripListForEarnings;
const DRIVER_NEARBY_THRESHOLD_MINIMUM_M = 0.75;
const DRIVER_NEARBY_THRESHOLD_MAXIMUM_M = 3;
async function tripListForDriverNearbyNotificationEligibility(firestore) {
    const minimumTimestampMs = (0, moment_1.default)().add(DRIVER_NEARBY_THRESHOLD_MINIMUM_M, 'minutes').valueOf();
    const maximumTimestampMs = (0, moment_1.default)().add(DRIVER_NEARBY_THRESHOLD_MAXIMUM_M, 'minutes').valueOf();
    const results = await firestore.list(ROOT_PATH, {
        where: [
            ['type', 'in', TripType_2.tripTypeRideshare],
            ['estimatedPickupTimestampMs', '>=', minimumTimestampMs],
            ['estimatedPickupTimestampMs', '<', maximumTimestampMs],
        ],
    });
    return results.map(result => (0, Trip_1.tripDeserialize)(result.value, result.id));
}
exports.tripListForDriverNearbyNotificationEligibility = tripListForDriverNearbyNotificationEligibility;
async function tripAutoCalculate(trip, database, firestore) {
    const driver = await (0, unwrap_1.default)(trip.driverId, driverId => (0, Driver_1.driverRead)(driverId, database));
    if ((0, Trip_1.tripIsInstantPayout)(trip)) {
        if (driver === null || driver === void 0 ? void 0 : driver.autoCalculateInstantEarnings) {
            await tripUpdateDriverEarningsD(trip, database, firestore);
        }
    }
    else {
        if (driver === null || driver === void 0 ? void 0 : driver.autoCalculateDelayedEarnings) {
            await tripUpdateDriverEarningsD(trip, database, firestore);
        }
    }
    if (trip.type === 'delivery') {
        await tripUpdateEstimate(trip, database, firestore);
    }
}
exports.tripAutoCalculate = tripAutoCalculate;
